/**
 * @deprecated
 * @function getCustIdByHostname
 * @returns {string} custId
 * @todo - Remove this function when the login system is done.
 */
function getCustIdByHostname() {
	const name = window.location.hostname;

	let custId = String(100);

	if (name === 'localhost') {
		custId = String(107);
	}

	return custId;
}

export default getCustIdByHostname;
